import {CreateInstance} from './config'
const noticeAPI = CreateInstance('notice')
export default noticeAPI
